<template>
	<input
		type="text"
		:name="name || undefined"
		:autocomplete="type"
		tabindex="-1"
		aria-hidden="true"
		class="absolute -left-[9999px] opacity-0 h-0 w-0 pointer-events-none"
	/>
</template>

<script lang="ts" setup>
export interface Props {
  type: string
  name?: string
}

withDefaults(defineProps<Props>(), {
  name: undefined,
});
</script>
